class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = 'df5ac04a';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1185.0.7';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Mon, 13 Jul 2026 16:15:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2026-07-13 12:14:32 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2026-07-13 12:14:32 Boston - df5ac04a - 1185.0.7';
export default BuildTags;
